(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  let cartReturnFocus;
  const drawer = $('.cart-drawer');
  const cartOpen = () => {
    document.body.classList.remove('menu-is-open');
    const toggle = $('.site-header__toggle');
    toggle?.setAttribute('aria-expanded', 'false');
    if (toggle) toggle.setAttribute('aria-label', toggle.dataset.openLabel);
    cartReturnFocus = document.activeElement === document.body ? $('[data-open-cart]') : document.activeElement;
    document.body.classList.add('cart-is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    $$('.site-header, #MainContent, .site-footer').forEach((element) => { element.inert = true; });
    $('.cart-drawer__header [data-close-cart]')?.focus();
  };
  const cartClose = () => {
    document.body.classList.remove('cart-is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    $$('.site-header, #MainContent, .site-footer').forEach((element) => { element.inert = false; });
    if (cartReturnFocus?.isConnected) cartReturnFocus.focus();
  };
  drawer?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { cartClose(); return; }
    if (event.key !== 'Tab') return;
    const focusable = $$('a[href],button:not([disabled]),input,select', $('.cart-drawer__panel'));
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });

  document.addEventListener('click', (event) => {
    const openCart = event.target.closest('[data-open-cart]');
    const closeCart = event.target.closest('[data-close-cart]');
    const localAnchor = event.target.closest('a[href^="#"]');

    if (openCart) { event.preventDefault(); cartOpen(); return; }
    if (closeCart) { cartClose(); return; }
    if (localAnchor) {
      const target = $(localAnchor.getAttribute('href'));
      if (target) { event.preventDefault(); target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }
    }
  });

  const menuButton = $('.site-header__toggle');
  if (menuButton) {
    const setMenu = (open) => {
      const wasOpen = document.body.classList.contains('menu-is-open');
      document.body.classList.toggle('menu-is-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? menuButton.dataset.closeLabel : menuButton.dataset.openLabel);
      if (open) $('.site-header__nav a')?.focus();
      else if (wasOpen) menuButton.focus();
    };
    menuButton.addEventListener('click', () => setMenu(!document.body.classList.contains('menu-is-open')));
    $$('.site-header__nav a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('click', (event) => {
      if (document.body.classList.contains('menu-is-open') && !event.target.closest('.site-header')) setMenu(false);
    });
    window.matchMedia('(max-width:900px)').addEventListener('change', event => { if (!event.matches) setMenu(false); });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { setMenu(false); cartClose(); }
    });
  }

  $$('.faq__trigger').forEach((button) => {
    const answer = $('.faq__answer', button.closest('.faq__item'));
    if (answer) answer.hidden = button.getAttribute('aria-expanded') !== 'true';
    button.addEventListener('click', () => {
      const item = button.closest('.faq__item');
      const wasOpen = item.classList.contains('is-open');
      $$('.faq__item').forEach((faq) => {
        faq.classList.remove('is-open');
        $('.faq__trigger', faq)?.setAttribute('aria-expanded', 'false');
        const panel = $('.faq__answer', faq);
        if (panel) panel.hidden = true;
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        if (answer) answer.hidden = false;
      }
    });
  });

  $$('.product-form').forEach((form) => {
    const variantSelect = $('[data-variant-select]', form);
    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const submit = $('button[type="submit"]', form);
      const price = $('[data-product-price]', form.parentElement);
      const availability = $('[data-availability]', form.parentElement);
      if (price) price.textContent = option.dataset.price;
      const mobilePrice = $('[data-mobile-product-price]', form);
      if (mobilePrice) mobilePrice.textContent = option.dataset.price;
      if (availability) availability.textContent = option.dataset.available === 'true' ? availability.dataset.availableLabel : availability.dataset.unavailableLabel;
      submit.disabled = option.dataset.available !== 'true';
      $('[data-submit-label]', submit).textContent = submit.disabled ? submit.dataset.soldLabel : submit.dataset.addLabel;
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = $('button[type="submit"]', form);
      const status = $('[data-form-status]', form);
      if (!submit || submit.disabled) return;
      submit.disabled = true;
      if (status) status.textContent = status.dataset.adding;
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number($('[name="id"]', form).value), quantity: Number($('[name="quantity"]', form)?.value || 1) })
        });
        if (!response.ok) throw new Error('Unable to add this item');
        try { sessionStorage.setItem('voriq-open-cart', '1'); } catch {}
        window.location.reload();
      } catch (error) {
        if (status) status.textContent = status.dataset.error;
        submit.disabled = false;
      }
    });
  });

  try {
    if (sessionStorage.getItem('voriq-open-cart') === '1') {
      sessionStorage.removeItem('voriq-open-cart');
      cartOpen();
    }
  } catch {}

  $$('.car-map').forEach((map) => {
    const title = $('[data-zone-title]', map);
    const description = $('[data-zone-description]', map);
    const number = $('.car-map__number', map);
    const buttons = $$('[data-car-zone], [data-zone-tab]', map);
    buttons.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const zone = trigger.dataset.carZone || trigger.dataset.zoneTab;
        const button = buttons.find((candidate) => candidate.dataset.carZone === zone);
        map.dataset.activeZone = zone;
        buttons.forEach((candidate) => {
          const active = (candidate.dataset.carZone || candidate.dataset.zoneTab) === zone;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
        title.textContent = button.dataset.title;
        description.textContent = button.dataset.copy;
        number.textContent = button.querySelector('span').textContent;
        $('[data-zone-heading]', map).textContent = button.dataset.heading;
        $('[data-zone-tool]', map).textContent = button.dataset.tool;
        $('[data-zone-tip]', map).textContent = button.dataset.tip;
      });
    });
  });

  $$('[data-gallery]').forEach((gallery) => {
    const slides = $$('[data-gallery-slide]', gallery);
    const thumbs = $('[data-gallery-thumbs]', gallery);
    if (!slides.length) return;
    let active = 0;
    const buttons = slides.map((slide, index) => {
      const original = $('img', slide);
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', slide.dataset.galleryLabel || original?.alt || String(index + 1));
      button.setAttribute('aria-controls', slide.id);
      const thumbSource = slide.dataset.galleryPoster || original?.currentSrc || original?.src;
      if (thumbSource) {
        const thumb = document.createElement('img');
        thumb.src = thumbSource;
        thumb.alt = '';
        thumb.width = 80;
        thumb.height = 80;
        thumb.loading = 'lazy';
        button.append(thumb);
      }
      if (slide.dataset.galleryKind === 'video') {
        button.classList.add('product-gallery__video-thumb');
        const play = document.createElement('span');
        play.className = 'product-gallery__play';
        play.setAttribute('aria-hidden', 'true');
        play.textContent = '▶';
        button.append(play);
      }
      button.addEventListener('click', () => show(index));
      thumbs.append(button);
      return button;
    });
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== active;
        const video = $('video', slide);
        if (video && i !== active) video.pause();
        if (video && i === active && video.preload === 'none') video.preload = 'metadata';
      });
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
      $('[data-gallery-counter]', gallery).textContent = `${active + 1} / ${slides.length}`;
      if (thumbs.scrollWidth > thumbs.clientWidth) thumbs.scrollTo({left:buttons[active].offsetLeft - thumbs.offsetLeft - thumbs.clientWidth / 2 + buttons[active].offsetWidth / 2,behavior:'auto'});
    };
    const firstVideo = slides.findIndex(slide => slide.dataset.galleryKind === 'video');
    const watchVideos = $('[data-gallery-watch]', gallery);
    if (watchVideos && firstVideo !== -1) {
      watchVideos.hidden = false;
      watchVideos.addEventListener('click', () => show(firstVideo));
    }
    $('[data-gallery-prev]', gallery).addEventListener('click', () => show(active - 1));
    $('[data-gallery-next]', gallery).addEventListener('click', () => show(active + 1));
    $('[data-gallery-controls]', gallery).hidden = false;
    thumbs.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(active + (event.key === 'ArrowRight' ? 1 : -1));
      buttons[active].focus();
    });
    show(0);
  });
})();
